import type { NavigatorType } from "single-spa/react-app/ProNavigator";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type ParamsType = {
    country: string;
    category: string;
    duration: string;
    state: string;
};

export class InternalLinksService {
    constructor(private swNavigator?: NavigatorType) {
        this.swNavigator = swNavigator ?? proNavigator;
    }

    getTopSitesLink = function (params?: ParamsType) {
        const {
            country = "999",
            category = "All",
            duration = "1m",
            state = "digitalsuite_marketresearch_webmarketanalysis_mapping",
        } = params || {};

        return this.swNavigator.href(state, { country, duration, category });
    };
}
